import z from "zod";
import { authedEndpoint } from "../../builder";

export const list = authedEndpoint.query(
    ({ search_params }) => ({
        method: "get",
        searchParams: search_params,
        url: "remote-storages",
    }),
    {
        input: z.object({
            search_params: z
                .object({
                    cursor: z.string(),
                    filter: z
                        .object({
                            name: z.string(),
                        })
                        .partial(),
                    per_page: z.number(),
                })
                .partial()
                .optional(),
        }),
        output: z.object({
            data: z.array(
                z.object({
                    id: z.number(),
                    name: z.string(),
                    config: z.object({
                        host: z.string(),
                        password: z.string(),
                        root: z.string().optional().nullable(),
                        username: z.string(),
                    }),
                }),
            ),
            links: z.object({
                first: z.string().nullable(),
                last: z.string().nullable(),
                next: z.string().nullable(),
                prev: z.string().nullable(),
            }),
            meta: z.object({
                next_cursor: z.string().nullable(),
                path: z.string(),
                per_page: z.number(),
                prev_cursor: z.string().nullable(),
            }),
        }),
    },
);
